<template>
  <div class="container" :class="{ 'container-mobile': isMobile }">

    <div class="row">

      <!-- left side column for desktop -->
      <div class="col-sm-12">

    <div :class="{ card: !isWidget || isMobile }">
      <div :class="{ 'card-body': !isWidget || isMobile }">

            <h2>Services Nearby</h2>
            <p>Explore routes near you</p>

            <div class="address-fields-container mb-5">
              <address-field
                class="mb-3 address-field"
                id="textfield-general"
                type="general"
                label="Enter Address"
                name="address"
                :selectAddressItemFunc="selectAddressItem">
              </address-field>
            </div>

            <all-routes-href-links :isFuture="false"></all-routes-href-links>

          </div>
        </div>

      </div>

    </div>
    <!-- end of row -->

  </div>
</template>

<script>
import AddressField from './AddressField'
import AllRoutesHrefLinks from './AllRoutesHrefLinks'
import mixinCommon from '../mixins/common'


export default {
  name: 'routes-nearby-widget',
  components: { AddressField, AllRoutesHrefLinks },
  props: {
    isFuture: Boolean,
    isWidget: Boolean,
  },
  mixins: [mixinCommon],
  data () {
    return {
    }
  },
  methods: {
    selectAddressItem (item) {
      // this.$router.push({
      //     name  : 'routes-nearby',
      //     params: { lat: item.lat, lng: item.lng}
      //   });
      // location.href = '/routes-nearby/' + item.lat + '/' + item.lng
      location.href = (this.$route.path.substr(0,3) === '/es') ? '/es/cercano/' + item.lat + '/' + item.lng : '/nearby/' + item.lat + '/' + item.lng
       // must reference router/index.js path for 'routes-nearby'
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../sass/_variables.scss'; // must be disabled when building for production

.address-fields-container {
  position: relative;
  padding-right: 50px;
}

.address-fields-container .input-group {
  margin: 20px 0;
}

.card {
  border-radius: 0;
  border-top-right-radius: 35px;
}

.card .card-body {
  color: $black-color;
}

h2 {
  color: $dark-blue;
}
@media (max-width: 640px) {
  .address-fields-container {
    padding-right: 10px;
  }
  .card-body {
    padding: 0.65rem;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/RoutesNearbyWidget.vue